export enum HexaIcons {
  ALERT_TRIANGLE = 'alert_triangle',
  ALERT_OCTAGON = 'alert_octagon',
  ARROW_DOWN = 'arrow_down',
  ARROW_LEFT = 'arrow_left',
  ARROW_RIGHT = 'arrow_right',
  ARROW_UP = 'arrow_up',
  BANK_TRANSFER = 'bank_transfer',
  BASKET = 'basket',
  BEER_BOTTLES = 'beer_bottles',
  CALENDAR = 'calendar',
  CALENDAR_CLOCK = 'calendar_clock',
  CASH = 'cash',
  CHECK = 'check',
  CHECKMARK = 'checkmark_2',
  CHECKMARK_3 = 'checkmark_3',
  CHECKLIST = 'checklist_1',
  CHEVRON_DOWN = 'chevron_down',
  CHEVRON_UP = 'chevron_up',
  CHEVRON_RIGHT = 'chevron_right',
  CLIPBOARD = 'clipboard',
  CLIPBOARD_PACKAGE = 'par',
  CLOCK = 'clock',
  CLOCK_HISTORY = 'history_2',
  COURRIER_MANAGEMENT = 'courrier_management',
  CREDIT_CARD = 'credit_card',
  CURRENCY = 'currency',
  DEBIT_CARD = 'debit_card',
  DOT = 'dot',
  DOWNLOAD = 'download',
  DYNAMIC_RADIUS = 'location_2',
  EDIT = 'edit_2',
  EXPRESS_DELIVERY = 'express_delivery',
  FILTER = 'filter',
  HELP_CIRCLE = 'help_circle',
  HOME = 'home',
  IDEAL_PORTFOLIO = 'mix_and_match',
  INFO = 'info',
  LOGOUT = 'logout',
  MAP_PIN = 'map_pin',
  NANO_DROP = 'warehouse',
  MAXIMIZE = 'maximize_2',
  MENU = 'menu',
  MESSAGE_SQUARE = 'messagae_square',
  MESSAGE_CIRCLE = 'message_circle',
  MORE_HORIZONTAL = 'more_horizontal',
  NUPAY = 'nubank',
  PHONE = 'phone',
  PIX = 'pix',
  REPEAT = 'repeat',
  RECEIPT = 'receipt',
  ROTATE_CW = 'rotate_cw',
  SEARCH = 'search',
  STAR_FILLED = 'star_filled',
  STAR_UNFILLED = 'star_unfilled',
  SORT = 'sort_default',
  TAG = 'tag',
  TRASH = 'trash_2',
  TRENDING_UP = 'trendinig_up',
  UPLOAD = 'upload',
  USER = 'user',
  WALLET = 'wallet',
  X = 'x',
  X_CIRCLE = 'x_circle',
  ZAP = 'zap',
  STORE_2 = 'store_2',
  PERCENT = 'percent',
  BARCODE = 'barcode',
}

type HexaV2BaseIcon = `${HexaIcons}`

type HexaIconsFontFamily = 'HexaIcons'

export const hexaBaseIcon = (
  icon: HexaIcons
): { name: HexaV2BaseIcon; fontFamily: HexaIconsFontFamily } => ({
  name: icon,
  fontFamily: 'HexaIcons',
})
